export interface PublicRuntimeConfig {
  API_BASE_URL: string;
  CLIENT_ID: string;
  BUILD_MODE: string;
  PUBLIC_ORIGIN?: string;
  IS_CLIENT?: boolean;
  COMPANY_ID?: string;
	SETUP_ONLY?: boolean;
}

let current: PublicRuntimeConfig | undefined;
const backendOrigin = () => {
  const override = process.env.REACT_APP_RUNTIME_CONFIG_URL;
  if (override) return override;
  const origin = window.location.port === '3000'
    ? `${window.location.protocol}//${window.location.hostname}:1234`
    : window.location.origin;
  return `${origin}/runtime-config.json`;
};

export async function loadRuntimeConfig(): Promise<void> {
  const response = await fetch(backendOrigin(), { cache: 'no-store' });
  if (!response.ok) throw new Error('Application settings are unavailable.');
  const value = await response.json();
  if (typeof value.CLIENT_ID !== 'string' || !value.CLIENT_ID ||
      typeof value.API_BASE_URL !== 'string' || typeof value.BUILD_MODE !== 'string') {
    throw new Error('Application settings are incomplete.');
  }
  current = { ...value, API_BASE_URL: value.API_BASE_URL || new URL(response.url || backendOrigin(), window.location.href).origin };
}

export function runtimeConfig(): PublicRuntimeConfig {
  if (current) return current;
  if (process.env.NODE_ENV === 'test') return {
    API_BASE_URL: '', CLIENT_ID: 'synthetic-client', BUILD_MODE: 'development',
    IS_CLIENT: process.env.REACT_APP_DEPLOYMENT === 'client',
  };
  throw new Error('Application settings have not loaded.');
}
